
import * as ActionTypes from './../actionTypes';

export default (state = {}, action) => {

    switch (action.type) {
        case ActionTypes.REQUEST_UPLOAD_CONTENT:
            
            return {
                ...state,
                loading: true,
                error: false,
                errorInfo: null,
                requestingData: action.data,
                response: null,
                isUploading: true
            }
        case ActionTypes.RECEIVED_UPLOAD_CONTENT:
            
            return {
                ...state,
                loading: false,
                response: action.res,
                error: false,
                errorInfo: null,
                isUploading: false

            }
        case ActionTypes.ERROR_UPLOAD_CONTENT:
            return {
                ...state,
                loading: false,
                error: true,
                errorInfo: action.err,
                response: null
            }
        case ActionTypes.CLEAR_UPLOAD_CONTENT:
            return {}
        default: return state;
    }
} 